import { render, staticRenderFns } from "./debug_tab_price.vue?vue&type=template&id=68200ff0&scoped=true&"
import script from "./debug_tab_price.vue?vue&type=script&lang=js&"
export * from "./debug_tab_price.vue?vue&type=script&lang=js&"
import style0 from "./debug_tab_price.vue?vue&type=style&index=0&id=68200ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68200ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260908145540/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68200ff0')) {
      api.createRecord('68200ff0', component.options)
    } else {
      api.reload('68200ff0', component.options)
    }
    module.hot.accept("./debug_tab_price.vue?vue&type=template&id=68200ff0&scoped=true&", function () {
      api.rerender('68200ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_tab_price.vue"
export default component.exports